import React, { useMemo } from "react";
import PropTypes from "prop-types";
import JoditEditor from "jodit-react";

function RichText({ value, onChange }) {
  const config = useMemo(
    () => ({
      buttons: [
        "paragraph",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "eraser",
        "|",
        "link",
        "quote",
        "align",
        "|",
        "undo",
        "redo",
        "|",
        "source",
      ],
      toolbarAdaptive: false,
      maxHeight: "50vh",
    }),
    [],
  );

  return <JoditEditor value={value || ""} config={config} onBlur={onChange} />;
}

RichText.defaultProps = {
  value: "",
};

RichText.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default RichText;
